import React, { useCallback } from 'react';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { Modal, ModalContent, ModalFooter, ModalHeader, RegularButton } from 'fronton-react';
import { t } from 'i18next';
import { UniqueOfferModalType } from 'types/page-model';
import { uniqueOfferModalHeader, uniqueOfferModalActionButton, uniqueOfferModalImage } from './styles';
import {
  DATA_QA_UNIQUE_OFFER_MODAL_ACTION_BUTTON_CLOSE,
  DATA_QA_UNIQUE_OFFER_MODAL_ACTION_BUTTON_HREF,
} from './constants';

type UniqueOfferModalProps = {
  data: UniqueOfferModalType | null;
  modalVisibility: boolean;
  setModalVisibility: (visible: boolean) => void;
};

export const UniqueOfferModal: React.FC<UniqueOfferModalProps> = ({
  data,
  modalVisibility,
  setModalVisibility,
}) => {
  const onClose = useCallback(
    (e?: React.SyntheticEvent) => {
      e?.stopPropagation();
      setModalVisibility(false);
    },
    [setModalVisibility],
  );

  const actionButton = data?.button?.href ? (
    <RegularButton
      data-qa={DATA_QA_UNIQUE_OFFER_MODAL_ACTION_BUTTON_HREF}
      className={uniqueOfferModalActionButton}
      as="a"
      href={data?.button?.href}
      target={data?.button?.target}
    >
      {data?.button?.text}
    </RegularButton>
  ) : (
    <RegularButton
      data-qa={DATA_QA_UNIQUE_OFFER_MODAL_ACTION_BUTTON_CLOSE}
      className={uniqueOfferModalActionButton}
      variant="secondary"
      onClick={onClose}
    >
      {t('uniqueOffer.modal.actionButton')}
    </RegularButton>
  );

  if (!modalVisibility) return null;

  return (
    <Modal size="s" variant="curtain" show={modalVisibility} onClose={onClose}>
      <ImagePlaceholder
        className={uniqueOfferModalImage}
        src={data?.icon || ''}
        alt={data?.title}
        width={220}
        height={140}
      />
      <ModalHeader className={uniqueOfferModalHeader} title={data?.title} />
      <ModalContent>{data?.text}</ModalContent>
      <ModalFooter>{actionButton}</ModalFooter>
    </Modal>
  );
};
